// extracted by mini-css-extract-plugin
module.exports = {"closeIcon":"_1lMVX","closeButton":"_2Sl--","header":"_1VHBc","container":"wWEUB","overlay":"rcxT3","content":"_2L6aW","withHeader":"_2JFyE","offsetContainer":"_2Azfx"};